import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { DialogComponent } from '@irb/irb-common/components/dialog/dialog.component';
import { DeleteSecuritiesDialogComponent } from '../delete-securities-dialog/delete-securities-dialog.component';
import { DeleteSecuritiesErrorDialogComponent } from '../delete-securities-error-dialog/delete-securities-error-dialog.component';
import { DeleteSecuritiesSoftDialogComponent } from '../delete-securities-soft-dialog/delete-securities-soft-dialog.component';
import { IrbModelsEvents } from '../irb-models.events';
import { ISecurity } from '../irb-models.model';

@Component({ standalone: false,
  selector: 'irb-delete-securities-symbol-dialog',
  templateUrl: './delete-securities-symbol-dialog.component.html',
  styleUrls: ['./delete-securities-symbol-dialog.component.scss']
})
export class DeleteSecuritiesSymbolDialogComponent implements OnInit {
  
  securityNonDeletedIds: Array<any>;
  securityDeletedIds: Array<any>;
  directDelete: Array<any>;
  softResponse :Array<any>;
  @ViewChild("dialog") dialog: DialogComponent;


  constructor(public dialogRef: MatDialogRef<DeleteSecuritiesSymbolDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private as: AppService) { }

  ngOnInit(): void {
    if(this.data.deleteSecurities)
    {
    this.securityNonDeletedIds = this.data.deleteSecurities as Array<ISecurity>;
    this.securityDeletedIds =this.data.deleteSecurities.deletedSelectedIds as Array<ISecurity>;
        // console.log(this.securityNonDeletedIds.length);
    }else if(this.data.cashdeleteSecurities)
    {
      this.softResponse =this.data.cashdeleteSecurities as Array<ISecurity>;
    }
    else{
      this.directDelete = this.data.softdDeleteSecurities;
    }
  }
  close() {
    if(this.dialogRef.close != undefined)
     this.dialogRef.close();
  }

  completeContains() {   
    if(this.securityNonDeletedIds)
    {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = this.data;
    this.dialog.open(DeleteSecuritiesErrorDialogComponent, config);
    }
    else if(this.directDelete)
    {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "600px";
    config.data = this.data;
    this.dialog.open(DeleteSecuritiesSoftDialogComponent, config);
    }
    else
    {
      const config = this.dialog.getDefaultConfig();
      config.minHeight = "100px";
      config.height = "auto";
      config.width = "600px";
      config.data = this.data;
      this.dialog.open(DeleteSecuritiesDialogComponent, config);

    }

    this.close();

  }

}
